// extracted by mini-css-extract-plugin
module.exports = {"container":"folderRenameModal_container__sCArJ","controls":"folderRenameModal_controls__PnTFh"};